// ----------------------------------------------------------------------
// <copyright file="Izenda.ValidationCategoriesPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ValidationCategoriesPopup component
 */
import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import { forEach, isEmpty, isNil } from 'lodash/fp';
import localizer from 'share/localization/Izenda.Localizer';

const ITEMS_SCROLL_LIMIT = 10;

@connect()
class ValidationCategoriesPopup extends Component{

  renderCategories() {
    const result = [];
    forEach(category => {
      result.push(
        <GridLayout.Row key={category.id}>
          <GridLayout.Col cols="12">
            {category.name}:
            {!isEmpty(category.reports) && this.renderReportsOrDashboards(category.reports)}
            {!isEmpty(category.dashboards) && this.renderReportsOrDashboards(category.dashboards)}
            {!isEmpty(category.subCategories) && this.renderSubCategories(category.subCategories)}
          </GridLayout.Col>
        </GridLayout.Row>
      );
    }, this.props.data);

    return result;
  }

  renderSubCategories(subCategories) {
    const result = [];
    forEach(subCategory => {
      result.push(
        <GridLayout.Row key={subCategory.id}>
          <GridLayout.Col cols="1" />
          <GridLayout.Col cols="11">
            {subCategory.name}:
            {!isEmpty(subCategory.reports) && this.renderReportsOrDashboards(subCategory.reports)}
            {!isEmpty(subCategory.dashboards) && this.renderReportsOrDashboards(subCategory.dashboards)}
          </GridLayout.Col>
        </GridLayout.Row>
      );
    }, subCategories);

    return result;
  }

  renderReportsOrDashboards(items) {
    const result = [];
    forEach(item => {
      result.push(
        <GridLayout.Row key={item.id}>
          <GridLayout.Col cols="1" />
          <GridLayout.Col cols="11">- {item.name}</GridLayout.Col>
        </GridLayout.Row>
      );
    }, items);

    return result;
  }

  renderBody() {
    return (
      <GridLayout className="izenda-PasswordOptions">
        <GridLayout.Row>{this.props.header}</GridLayout.Row>
        {this.renderCategories()}
        <GridLayout.Row>{this.props.footer}</GridLayout.Row>
      </GridLayout>
    );
  }

  getNumOfItems = (categories) => {
    if(isNil(categories)) return 0;

    let result = categories.length;
    forEach(category => {
      result += !isNil(category.reports) ? category.reports.length : 0;
      if(!isNil(category.subCategories)) {
        result += !isNil(category.subCategories) ? category.subCategories.length : 0;
        forEach(subCategory => {
          result += !isNil(subCategory.reports) ? subCategory.reports.length : 0;
        }, category.subCategories);
      }
    }, categories);
    return result;
  }

  render() {
    const props = this.props;
    const numOfItems = this.getNumOfItems(props.data);
    const useScroll = numOfItems > ITEMS_SCROLL_LIMIT;

    return (
      <Popup visible type="error" onClosing={props.onReject} autoClose={false}>
        <Popup.Header title={localizer.getText('COMMON_MESSAGES_ERROR')} className="u_floatLeft" />
        <Popup.Body>
          {useScroll ? (
            <div className='izenda-DefaultPopupContentWrapper'>
              <ScrollBox>
                {this.renderBody()}
              </ScrollBox>
            </div>
          ) : this.renderBody()}
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="cancel">{localizer.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default ValidationCategoriesPopup;


// WEBPACK FOOTER //
// ./ui/modules/Settings/Izenda.ValidationCategoriesPopup.js